import DynamicTable from '@atlaskit/dynamic-table';
import EmptyState from '@atlaskit/empty-state';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import React from 'react';
import NoResultView from "../../../utils/NoResultView";
import { REPORTS_NO_RESULT_SUBTITLE, REPORTS_NO_RESULT_TITLE } from "../PartnerReports.constants";
import { CloudConversionsHeader, getCloudConversionsBody } from "./CloudConversionsTableData";
import { useCloudConversions } from "./hooks";
import GenericErrorImage from "../../../../common/components/generic-error.svg";

const CloudConversions = props => {
  var _cloudConversionsAPIR;

  const {
    cloudConversionsAPIResponse,
    pending,
    error
  } = useCloudConversions(props.mpacBaseUrl, props.partnerId, props.queryParams);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(EmptyState, {
    header: "We ran into a little trouble",
    description: "It might just be a hiccup. Try again in a bit.",
    imageUrl: GenericErrorImage
  }), !error && /*#__PURE__*/React.createElement(DynamicTable, {
    head: CloudConversionsHeader,
    rows: getCloudConversionsBody(cloudConversionsAPIResponse),
    isLoading: pending,
    rowsPerPage: DynamicTableUtils.getRowsPerPage((_cloudConversionsAPIR = cloudConversionsAPIResponse === null || cloudConversionsAPIResponse === void 0 ? void 0 : cloudConversionsAPIResponse.addons.length) !== null && _cloudConversionsAPIR !== void 0 ? _cloudConversionsAPIR : 0),
    defaultSortKey: "conversions",
    emptyView: /*#__PURE__*/React.createElement(NoResultView, {
      title: REPORTS_NO_RESULT_TITLE,
      subtitle: REPORTS_NO_RESULT_SUBTITLE
    })
  }));
};

export default /*#__PURE__*/React.memo(CloudConversions);